import * as a from '@mitranim/js/all.mjs'

export class Cookie extends a.Cookie {
  // Also affects `Cookie.expired`.
  static make(key, val) {
    return super.make(key, val).root().durable().lax()
  }
}

export class Cookies extends a.Cookies {get cls() {return Cookie}}

/*
Difference from `a.Cookies`: reparses the current `document.cookie` every time
we're trying to read a cookie, ensuring up-to-date state.
*/
export class ClientCookies extends a.Emp {
  all() {return Cookies.native()}
  get(key) {return this.all().get(key)}
  getVal(key) {return this.get(key)?.value}
  setVal(key, val) {Cookie.make(key, val).install()}
}
